import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  getNotificationSettings: function() {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-notification-settings");
  },
  getNotification: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-notification-content/" + params);
  },
  addUpdateNotificationSetting: function(notification,getBy,shownUp) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/notification-setting", {
      get_by: getBy,
      shown_up: shownUp,
      course_assign: notification.course_assign,
      playlist_assign: notification.playlist_assign,
      deadline_set: notification.deadline_set,
      deadline_changed: notification.deadline_changed,
      missed_deadline: notification.missed_deadline,
      deadline_before: notification.deadline_before,
      idle_after: notification.idle_after,
      external_deadline_before: notification.external_deadline_before,
      course_status_changed: notification.course_status_changed,
      course_completion: notification.course_completion,
    });
  },
  addUpdatePartnerNotificationSetting: function(notification,notificationContent,getBy,shownUp) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/partner-notification-setting", {
      get_by: getBy,
      shown_up: shownUp,
      course_assign: notification.course_assign,
      playlist_assign: notification.playlist_assign,
      deadline_set: notification.deadline_set,
      deadline_changed: notification.deadline_changed,
      missed_deadline: notification.missed_deadline,
      deadline_before: notification.deadline_before,
      idle_after: notification.idle_after,
      external_deadline_before: notification.external_deadline_before,
      course_status_changed: notification.course_status_changed,
      course_completion: notification.course_completion,
      admin_setting: notification.admin_setting,
      auto_archived: notification.auto_archived,

      course_assign_content: notificationContent.course_assign,
      playlist_assign_content: notificationContent.playlist_assign,
      deadline_set_content: notificationContent.deadline_set,
      deadline_changed_content: notificationContent.deadline_changed,
      missed_deadline_content: notificationContent.missed_deadline,
      deadline_before_content: notificationContent.deadline_before,
      idle_after_content: notificationContent.idle_after,
      external_deadline_before_content: notificationContent.external_deadline_before,
      course_status_changed_content: notificationContent.course_status_changed,
      course_completion_content: notificationContent.course_completion,
      auto_archived_content: notificationContent.auto_archived,
    });
  },
  addUpdateNotificationContent: function(content,ctype, course_id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/notification-content", {
      content: content,
      content_type: ctype,
      course_id: course_id
    });
  },
  addUpdatePartnerNotificationContent: function(content,ctype, adminSetting) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/partner-notification-content", {
      content: content,
      content_type: ctype,
      admin_setting: adminSetting
    });
  },
  getNotificationWithCourseId: function(params,course_id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-notification-course-content/" + course_id +'?ctype='+params );
  },
  getCourseNotificationSetting: function(course_id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-notification-course-setting/" + course_id );
  },
  getNotificationSettingsWithContent: function(companyId = "") {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-notification-settings-content"+ companyId);
  },
  addUpdateNotificationSettingsWithContent: function(notification,notificationContent,getBy,shownUp,headerS3Url, headerFileDetails, footerS3Url, footerFileDetails,companyId){
    return axios.post(IMPROVE_CONFIG.API_URL + "/update-notification-settings-content", {
      get_by: getBy,
      shown_up: shownUp,
      course_assign: notification.course_assign,
      playlist_assign: notification.playlist_assign,
      deadline_set: notification.deadline_set,
      deadline_changed: notification.deadline_changed,
      missed_deadline: notification.missed_deadline,
      deadline_before: notification.deadline_before,
      idle_after: notification.idle_after,
      external_deadline_before: notification.external_deadline_before,
      course_status_changed: notification.course_status_changed,
      course_completion: notification.course_completion,
      auto_archived: notification.auto_archived,
      welcome_mail: notification.welcome_mail,
      customized_notification: notification.customized_notification,
      reset_password: notification.reset_password,
      admin_setting: notification.admin_setting,

      course_assign_content: notificationContent.course_assign,
      playlist_assign_content: notificationContent.playlist_assign,
      deadline_set_content: notificationContent.deadline_set,
      deadline_changed_content: notificationContent.deadline_changed,
      missed_deadline_content: notificationContent.missed_deadline,
      deadline_before_content: notificationContent.deadline_before,
      idle_after_content: notificationContent.idle_after,
      external_deadline_before_content: notificationContent.external_deadline_before,
      course_status_changed_content: notificationContent.course_status_changed,
      course_completion_content: notificationContent.course_completion,
      auto_archived_content: notificationContent.auto_archived,
      welcome_mail_content: notificationContent.welcome_mail,
      reset_password_content: notificationContent.reset_password,
      header_s3_url: headerS3Url,
      header_file: headerFileDetails,
      footer_s3_url: footerS3Url,
      footer_file: footerFileDetails,
      button_colour: notificationContent.button_colour,
      text_colour: notificationContent.text_colour,

      company_id: companyId,
    });
  },
  updateCourseNotification: function(notification = {},notificationContent = {}, getBy = 2, shownUp = 3,courseId){
     return axios.post(IMPROVE_CONFIG.API_URL + "/update-course-notifications", {
      get_by: getBy,
      shown_up: shownUp,
      deadline_set: notification.deadline_set,
      deadline_changed: notification.deadline_changed,
      missed_deadline: notification.missed_deadline,
      deadline_before: notification.deadline_before,
      idle_after: notification.idle_after,
      external_deadline_before: notification.external_deadline_before,
      course_status_changed: notification.course_status_changed,
      course_completion: notification.course_completion,
      auto_archived: notification.auto_archived,
      deadline_set_content: notificationContent.deadline_set,
      deadline_changed_content: notificationContent.deadline_changed,
      missed_deadline_content: notificationContent.missed_deadline,
      deadline_before_content: notificationContent.deadline_before,
      idle_after_content: notificationContent.idle_after,
      course_status_changed_content: notificationContent.course_status_changed,
      course_completion_content: notificationContent.course_completion,
      auto_archived_content: notificationContent.auto_archived,
      course_id: courseId
     });
  }
};